import instance from "./auth";

export const getAll = async (params) => {
    const {data} = await instance.get("/dashboards", {
        params,
    });
    return data;
}


